import { Badge as CXBadge } from '@sanlamcx/react-ui-next-badge';

type Badge = typeof CXBadge;
export const Badge: Badge = CXBadge;
